function isHttpUrl(candidate: string): boolean {
    try {
        const url = new URL(candidate)
        return url.protocol === 'http:' || url.protocol === 'https:'
    } catch {
        return false
    }
}

const STATIC_RETURN_URL_FALLBACKS = [
    process.env.NEXT_PUBLIC_CLIENTS_BASE_URL,
    process.env.NEXT_PUBLIC_LINK_BASE_URL
] as const

export function isUnsafeStripeEmbedOrigin(): boolean {
    if (typeof window === 'undefined') {
        return false
    }

    return window.location.protocol === 'file:' || window.location.origin === 'null'
}

export function stripeEmbedOriginErrorMessage(): string {
    return 'Kartenzahlung funktioniert nicht auf file://-Seiten. Bitte testen Sie das Widget über eine https://-URL (z. B. https://tebuto.local/widget-local-test).'
}

export function buildBookingWidgetPaymentReturnUrl(): string {
    if (typeof window === 'undefined') {
        throw new Error('Booking widget return URL is not available during SSR')
    }

    const url = new URL(window.location.href)
    url.searchParams.delete('session_id')
    return url.toString()
}

export function buildStripeCheckoutSessionReturnUrl(): string {
    const url = new URL(buildBookingWidgetPaymentReturnUrl())
    const separator = url.search ? '&' : '?'
    return `${url.origin}${url.pathname}${url.search}${separator}session_id={CHECKOUT_SESSION_ID}${url.hash}`
}

export function resolveStripeConfirmReturnUrl(preferred?: string): string {
    const candidates = [
        preferred,
        typeof window !== 'undefined' ? window.location.href : undefined,
        ...STATIC_RETURN_URL_FALLBACKS
    ]

    for (const candidate of candidates) {
        if (!candidate?.trim()) {
            continue
        }

        if (isHttpUrl(candidate)) {
            return new URL(candidate).toString()
        }
    }

    throw new Error('Stripe return URL is not available')
}
